import { create } from 'zustand';
import {
  AliasRequestI,
  defaultAliasRequest,
  filtersAliasDefault,
  FiltersAliasInterface,
} from '../../models/Alias';

interface InterfaceAliasStore {
  filterValuesDefault: FiltersAliasInterface;
  filterValuesChange: FiltersAliasInterface;
  updateFiltersChange: (obj: Partial<FiltersAliasInterface>) => void;
  updateFiltersDefault: (obj: FiltersAliasInterface) => void;
  aliasRequestObject: AliasRequestI;
  updateAliasRequest: (obj: Partial<AliasRequestI>) => void;
  loadingAlias: boolean;
  updateLoadingAlias: (value: boolean) => void;
}

const useAliasStore = create<InterfaceAliasStore>(set => ({
  filterValuesDefault: filtersAliasDefault,
  filterValuesChange: filtersAliasDefault,

  aliasRequestObject: defaultAliasRequest,
  updateAliasRequest: obj => {
    set(state => ({
      aliasRequestObject: { ...state.aliasRequestObject, ...obj },
    }));
  },

  updateFiltersChange: obj => {
    set(state => ({
      filterValuesChange: { ...state.filterValuesChange, ...obj },
    }));
  },

  updateFiltersDefault: obj => set({ filterValuesDefault: obj }),

  loadingAlias: true,
  updateLoadingAlias: value => set({ loadingAlias: value }),
}));

export default useAliasStore;
